import { useRouter } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ErrorState, LoadingState, EmptyState } from "@/components/states";

export function RouteError({ error, reset }: { error: unknown; reset?: () => void }) {
  const router = useRouter();
  const { t } = useTranslation();
  return (
    <div className="mx-auto w-full max-w-3xl px-4 py-8">
      <ErrorState
        error={error}
        onRetry={() => {
          router.invalidate();
          reset?.();
        }}
        action={
          <Button size="sm" variant="outline" onClick={() => router.history.back()}>
            <ArrowLeft className="mr-2 h-4 w-4" aria-hidden />
            {t("states.back")}
          </Button>
        }
      />
    </div>
  );
}

export function RoutePending() {
  return (
    <div className="mx-auto w-full max-w-3xl px-4 py-8">
      <LoadingState />
    </div>
  );
}

export function RouteNotFound() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto w-full max-w-3xl px-4 py-8">
      <EmptyState title={t("states.notFoundTitle")} description={t("states.notFoundBody")} />
    </div>
  );
}
